<template>
  <div class="item" v-if="item" @click="godetail">
    <div class="item-img" v-if="showPic" :style="{backgroundImage:'url('+item.cover_img+')'}">
      <img :src="item.cover_img" alt="">
    </div>
    <div class="item-txt" :class="{'hasPic':showPic}">
      <div class="item-title" :title="item.name">{{item.name}}</div>
      <div class="item-sub">
        <span v-if="item.type_tag_name">{{item.type_tag_name  | formatShowFirst}}</span>
        <span v-if="item.show_time">{{item.show_time | formatStandardDate}}</span>
        <span v-if="item.performance_unit" :title="item.performance_unit">表演：{{item.performance_unit | formatStandardSep}}</span>
      </div>
    </div>
    
  </div>
</template>

<script>
import colums from '../../colums/colums.js'
export default {
  name: 'programCateItem',
  props: {
    showPic:{
      type:Boolean,
      default:false
    },
    item:Object,
    showpath:String,
  },
  data(){
    return{
      colums:colums.jmkcate
      
    }
  },
  mounted() {
    
  },
  methods: {
    godetail(){
        let matchObj = this.colums.find(newitem=>{return newitem.id == this.item.type_id})
        let hash = this.$utils.hashNum(this.item.no_access)
        this.$router.push({
            path:matchObj.path+"/"+this.item.id+"/"+hash
          })
          return
        try{
          let link = this.$router.resolve({
            path:matchObj.path+"/"+this.item.id+"/"+hash
          })
          window.open(link.href,'_blank')
        }catch(err){
          this.$router.push({
            path:matchObj.path+"/"+this.item.id+"/"+hash
          })
        }
        
      }
  },
}
</script>
<style scoped >
  .item .item-img{
      background: center center no-repeat;
      background-size:cover;
    }
    .item .item-img img{opacity: 0;}

</style>